"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { d: "M9.8489 18.1511C8.82778 18.1511 8 18.9789 8 20C8 21.0211 8.82778 21.8489 9.8489 21.8489H18.1511V30.1511C18.1511 31.1722 18.9789 32 20 32C21.0211 32 21.8489 31.1722 21.8489 30.1511L21.8489 21.8489L30.1511 21.8489C31.1722 21.8489 32 21.0211 32 20C32 18.9789 31.1722 18.1511 30.1511 18.1511L21.8489 18.1511L21.8489 9.8489C21.8489 8.82778 21.0211 8 20 8C18.9789 8 18.1511 8.82778 18.1511 9.8489V18.1511L9.8489 18.1511Z", fill: colour }));
};
//# sourceMappingURL=Plus.js.map